export const excludedCities = ['Paris'];
